exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  flex-grow: 1;\n}\n\n.file-selector {\n  display: block;\n  padding-top: 24px;\n}\n\n.mdl-dialog__actions {\n  display: block;\n}\n\n.mdl-dialog__actions upload-dialog-action-buttons {\n  float: right;\n}\n\n", ""]);

// exports
